<template>
  <div class="botao">
    <div class="content">
    <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Botao',
  props: {
    texto: String
  }
}
</script>

<style scoped>
.botao {
    background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
    width: 200px;
    height: 50px;
    border-radius: 6px;
    -moz-border-radius:6px;
    -webkit-border-radius:6px;
    color: white;
    font-size: 1.2em;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
}
.content {
    margin: auto;
}
</style>
